type AccountIdFieldProps = {
  value: string;
};

export const AccountIdField = ({ value }: AccountIdFieldProps) => (
  <p className="pf-c-form-control">{value}</p>
);